var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAitClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 2.66669C5.05378 2.66669 2.66669 5.05378 2.66669 8.00002C2.66669 10.9463 5.05378 13.3334 8.00002 13.3334C10.9463 13.3334 13.3334 10.9463 13.3334 8.00002C13.3334 5.05378 10.9463 2.66669 8.00002 2.66669ZM9.98905 9.39787L9.55894 9.9355C9.53072 9.97079 9.49582 10.0002 9.45624 10.022C9.41665 10.0438 9.37317 10.0576 9.32825 10.0626C9.28334 10.0676 9.23788 10.0637 9.19448 10.0511C9.15108 10.0385 9.11058 10.0175 9.07529 9.98927L7.63443 8.92002C7.53375 8.83942 7.45249 8.7372 7.39665 8.62095C7.34082 8.5047 7.31183 8.37738 7.31185 8.24841V4.90325C7.31185 4.81199 7.3481 4.72447 7.41263 4.65994C7.47716 4.59541 7.56468 4.55916 7.65593 4.55916H8.34411C8.43536 4.55916 8.52288 4.59541 8.58741 4.65994C8.65194 4.72447 8.68819 4.81199 8.68819 4.90325V8.00002L9.9355 8.914C9.97081 8.94224 10.0002 8.97717 10.022 9.01677C10.0438 9.05638 10.0576 9.0999 10.0626 9.14484C10.0675 9.18977 10.0636 9.23525 10.051 9.27867C10.0384 9.32208 10.0173 9.36259 9.98905 9.39787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAitClock);
export default __webpack_public_path__ + "static/media/aitClock.0f9feea4708e5e727eff605ee0db7769.svg";
export { ForwardRef as ReactComponent };